import { HttpInterceptorFn } from '@angular/common/http';

export function cleanUrl(url: string): string {
  if (!url) {
    return url;
  }

  return url.replace(/([^:]\/)\/+/g, '$1');
}

export const urlCleanerInterceptor: HttpInterceptorFn = (req, next) => {
  const cleanedUrl = cleanUrl(req.url);

  if (cleanedUrl !== req.url) {
    req = req.clone({
      url: cleanedUrl
    });
  }

  return next(req);
};
